export default __webpack_public_path__ + "static/media/app-store.1104cd1f.svg";